




































































import { Component } from "vue-property-decorator";
import { VFields } from "../../../models/v-fields";
import { Base } from "../../../components/common/base";
import { vehicleInventoryService } from "../../../shared";
import { NotificationType } from "@/helper/enum";
// import { VinDecodeRequest } from '@/Alynk.dtos';
// import { SaleAccount } from '../../../models/admin/sale.account';

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class VPICSavePage extends Base {
  public stores: any[];
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public disableSubmitButton: boolean = false;
  public created(): void {
    this.setFields();
  }
  public searchVin: string = "";
  public searchModelYear: string = "";

  public btnLoading: boolean = false;

  // public searchType: VinDecodeRequest[] = [];

  public vpicModel: any = {
    abs: "",
    activeSafetySysNote: "",
    adaptiveCruiseControl: "",
    adaptiveDrivingBeam: "",
    adaptiveHeadlights: "",
    additionalErrorText: "",
    airBagLocCurtain: "",
    airBagLocFront: "",
    airBagLocKnee: "",
    airBagLocSeatCushion: "",
    airBagLocSide: "",
    autoReverseSystem: "",
    automaticPedestrianAlertingSound: "",
    axleConfiguration: "",
    axles: "",
    basePrice: "",
    batteryA: "",
    batteryA_to: "",
    batteryCells: "",
    batteryInfo: "",
    batteryKWh: "",
    batteryKWh_to: "",
    batteryModules: "",
    batteryPacks: "",
    batteryType: "",
    batteryV: "",
    batteryV_to: "",
    bedLengthIN: "",
    bedType: "",
    blindSpotIntervention: "",
    blindSpotMon: "",
    bodyCabType: "",
    bodyClass: "",
    brakeSystemDesc: "",
    brakeSystemType: "",
    busFloorConfigType: "",
    busLength: "",
    busType: "",
    caN_AACN: "",
    cib: "",
    cashForClunkers: "",
    chargerLevel: "",
    chargerPowerKW: "",
    coolingType: "",
    curbWeightLB: "",
    customMotorcycleType: "",
    daytimeRunningLight: "",
    destinationMarket: "",
    displacementCC: "",
    displacementCI: "",
    displacementL: "",
    doors: "",
    driveType: "",
    driverAssist: "",
    dynamicBrakeSupport: "",
    edr: "",
    esc: "",
    evDriveUnit: "",
    electrificationLevel: "",
    engineConfiguration: "",
    engineCycles: "",
    engineCylinders: "",
    engineHP: "",
    engineHP_to: "",
    engineKW: "",
    engineManufacturer: "",
    engineModel: "",
    entertainmentSystem: "",
    errorCode: "",
    errorText: "",
    forwardCollisionWarning: "",
    fuelInjectionType: "",
    fuelTypePrimary: "",
    fuelTypeSecondary: "",
    gcwr: "",
    gcwR_to: "",
    gvwr: "",
    gvwR_to: "",
    keylessIgnition: "",
    laneCenteringAssistance: "",
    laneDepartureWarning: "",
    laneKeepSystem: "",
    lowerBeamHeadlampLightSource: "",
    make: "",
    makeID: "",
    manufacturer: "",
    manufacturerId: "",
    model: "",
    modelID: "",
    modelYear: "",
    motorcycleChassisType: "",
    motorcycleSuspensionType: "",
    ncsaBodyType: "",
    ncsaMake: "",
    ncsaMapExcApprovedBy: "",
    ncsaMapExcApprovedOn: "",
    ncsaMappingException: "",
    ncsaModel: "",
    ncsaNote: "",
    nonLandUse: "",
    note: "",
    otherBusInfo: "",
    otherEngineInfo: "",
    otherMotorcycleInfo: "",
    otherRestraintSystemInfo: "",
    otherTrailerInfo: "",
    parkAssist: "",
    pedestrianAutomaticEmergencyBraking: "",
    plantCity: "",
    plantCompanyName: "",
    plantCountry: "",
    plantState: "",
    possibleValues: "",
    pretensioner: "",
    rearAutomaticEmergencyBraking: "",
    rearCrossTrafficAlert: "",
    rearVisibilitySystem: "",
    saeAutomationLevel: "",
    saeAutomationLevel_to: "",
    seatBeltsAll: "",
    seatRows: "",
    seats: "",
    semiautomaticHeadlampBeamSwitching: "",
    series: "",
    series2: "",
    steeringLocation: "",
    suggestedVIN: "",
    tpms: "",
    topSpeedMPH: "",
    trackWidth: "",
    tractionControl: "",
    trailerBodyType: "",
    trailerLength: "",
    trailerType: "",
    transmissionSpeeds: "",
    transmissionStyle: "",
    trim: "",
    trim2: "",
    turbo: "",
    vin: "",
    valveTrainDesign: "",
    vehicleDescriptor: "",
    vehicleType: "",
    wheelBaseLong: "",
    wheelBaseShort: "",
    wheelBaseType: "",
    wheelSizeFront: "",
    wheelSizeRear: "",
    wheels: "",
    windows: "",
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "backToList") {
      if (history.state && history.length > 1) {
        history.back();
      }
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "0",
      type: "button",
      title: "Back",
      disabled: false,
      visible: true,
      class: "btn",
      label: "Back",
      click: "backToList",
      icon: "fas fa-arrow-left",
    });
    this.$emit("updateToolBar", buttons);
  }
  public async mounted(): Promise<void> {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "saleaccount");

    // Toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setFields(): void {
    this.formFields = [
      {
        key: "abs",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "ABS",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.abs != undefined && this.vpicModel.abs != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "activeSafetySysNote",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Active Safety Sys Note",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.activeSafetySysNote != undefined &&
            this.vpicModel.activeSafetySysNote != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "adaptiveCruiseControl",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Adaptive Cruise Control",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.adaptiveCruiseControl != undefined &&
            this.vpicModel.adaptiveCruiseControl != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "adaptiveDrivingBeam",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Adaptive Driving Beam",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.adaptiveDrivingBeam != undefined &&
            this.vpicModel.adaptiveDrivingBeam != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "adaptiveHeadlights",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Adaptive Headlights",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.adaptiveHeadlights != undefined &&
            this.vpicModel.adaptiveHeadlights != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "additionalErrorText",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Additional Error Text",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.additionalErrorText != undefined &&
            this.vpicModel.additionalErrorText != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "airBagLocCurtain",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Air Bag Loc Curtain",
          required: false,
          disabled: true,
          loading: false,
          display:
            this.vpicModel.airBagLocCurtain != undefined &&
            this.vpicModel.airBagLocCurtain != ""
              ? true
              : false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "airBagLocFront",
        type: "v-alynk-text-field",
        required: false,
        templateOptions: {
          label: "Air Bag Loc Front",
          required: false,
          disabled: true,
          display:
            this.vpicModel.airBagLocFront != undefined &&
            this.vpicModel.airBagLocFront != ""
              ? true
              : false,
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "AirBagLocKnee",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.airBagLocKnee != undefined &&
            this.vpicModel.airBagLocKnee != ""
              ? true
              : false,
          label: "Air Bag Loc Knee",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "airBagLocSeatCushion",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.airBagLocSeatCushion != undefined &&
            this.vpicModel.airBagLocSeatCushion != ""
              ? true
              : false,
          label: "Air Bag Loc Seat Cushion",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "airBagLocSide",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.airBagLocSide != undefined &&
            this.vpicModel.airBagLocSide != ""
              ? true
              : false,
          label: "Air Bag Loc Side",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "autoReverseSystem",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.autoReverseSystem != undefined &&
            this.vpicModel.autoReverseSystem != ""
              ? true
              : false,
          label: "Auto Reverse System",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "automaticPedestrianAlertingSound",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.automaticPedestrianAlertingSound != undefined &&
            this.vpicModel.automaticPedestrianAlertingSound != ""
              ? true
              : false,
          label: "Automatic Pedestrian Alerting Sound",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "axleConfiguration",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.axleConfiguration != undefined &&
            this.vpicModel.axleConfiguration != ""
              ? true
              : false,
          label: "Axle Configuration",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "axles",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.axles != undefined && this.vpicModel.axles != ""
              ? true
              : false,
          label: "Axles",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "basePrice",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.basePrice != undefined &&
            this.vpicModel.basePrice != ""
              ? true
              : false,
          label: "Base Price",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryA",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryA != undefined &&
            this.vpicModel.batteryA != ""
              ? true
              : false,
          label: "Battery A",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryA_to",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryA_to != undefined &&
            this.vpicModel.batteryA_to != ""
              ? true
              : false,
          label: "Battery A_to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryCells",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryCells != undefined &&
            this.vpicModel.batteryCells != ""
              ? true
              : false,
          label: "Battery Cells",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryInfo",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryInfo != undefined &&
            this.vpicModel.batteryInfo != ""
              ? true
              : false,
          label: "BatteryInfo",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryKWh",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryKWh != undefined &&
            this.vpicModel.batteryKWh != ""
              ? true
              : false,
          label: "Battery KWh",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryKWh_to",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryKWh_to != undefined &&
            this.vpicModel.batteryKWh_to != ""
              ? true
              : false,
          label: "Battery KWh_to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryModules",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryModules != undefined &&
            this.vpicModel.batteryModules != ""
              ? true
              : false,
          label: "Battery Modules",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryPacks",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryPacks != undefined &&
            this.vpicModel.batteryPacks != ""
              ? true
              : false,
          label: "Battery Packs",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryType",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryType != undefined &&
            this.vpicModel.batteryType != ""
              ? true
              : false,
          label: "Battery Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryV",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryV != undefined &&
            this.vpicModel.batteryV != ""
              ? true
              : false,
          label: "Battery V",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "batteryV_to",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.batteryV_to != undefined &&
            this.vpicModel.batteryV_to != ""
              ? true
              : false,
          label: "Battery V_to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "bedLengthIN",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.bedLengthIN != undefined &&
            this.vpicModel.bedLengthIN != ""
              ? true
              : false,
          label: "Bed Length IN",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "bedType",
        required: false,
        type: "v-alynk-text-field",

        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.bedType != undefined && this.vpicModel.bedType != ""
              ? true
              : false,
          label: "Bed Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "blindSpotIntervention",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.blindSpotIntervention != undefined &&
            this.vpicModel.blindSpotIntervention != ""
              ? true
              : false,
          label: "Blind Spot Intervention",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "blindSpotMon",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.blindSpotMon != undefined &&
            this.vpicModel.blindSpotMon != ""
              ? true
              : false,
          label: "Blind Spot Mon",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "bodyCabType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.bodyCabType != undefined &&
            this.vpicModel.bodyCabType != ""
              ? true
              : false,
          label: "Body Cab Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "bodyClass",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.bodyClass != undefined &&
            this.vpicModel.bodyClass != ""
              ? true
              : false,
          label: "Body Class",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "brakeSystemDesc",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.brakeSystemDesc != undefined &&
            this.vpicModel.brakeSystemDesc != ""
              ? true
              : false,
          label: "Brake System Desc",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "brakeSystemType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.brakeSystemType != undefined &&
            this.vpicModel.brakeSystemType != ""
              ? true
              : false,
          label: "Brake System Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "busFloorConfigType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.busFloorConfigType != undefined &&
            this.vpicModel.busFloorConfigType != ""
              ? true
              : false,
          label: "Bus Floor ConfigType",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "busLength",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.busLength != undefined &&
            this.vpicModel.busLength != ""
              ? true
              : false,
          label: "Bus Length",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "busType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.busType != undefined && this.vpicModel.busType != ""
              ? true
              : false,
          label: "Bus Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "caN_AACN",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.caN_AACN != undefined &&
            this.vpicModel.caN_AACN != ""
              ? true
              : false,
          label: "CAN AACN",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "cib",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.cib != undefined && this.vpicModel.cib != ""
              ? true
              : false,
          label: "CIB",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "cashForClunkers",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.cashForClunkers != undefined &&
            this.vpicModel.cashForClunkers != ""
              ? true
              : false,
          label: "Cash For Clunkers",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "chargerLevel",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.chargerLevel != undefined &&
            this.vpicModel.chargerLevel != ""
              ? true
              : false,
          label: "Charger Level",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "chargerPowerKW",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.chargerPowerKW != undefined &&
            this.vpicModel.chargerPowerKW != ""
              ? true
              : false,
          label: "Charger Power KW",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "coolingType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.coolingType != undefined &&
            this.vpicModel.coolingType != ""
              ? true
              : false,
          label: "Cooling Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "curbWeightLB",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.curbWeightLB != undefined &&
            this.vpicModel.curbWeightLB != ""
              ? true
              : false,
          label: "Curb Weight LB",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "customMotorcycleType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.customMotorcycleType != undefined &&
            this.vpicModel.customMotorcycleType != ""
              ? true
              : false,
          label: "Custom Motorcycle Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "daytimeRunningLight",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.daytimeRunningLight != undefined &&
            this.vpicModel.daytimeRunningLight != ""
              ? true
              : false,
          label: "Daytime Running Light",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "destinationMarket",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.destinationMarket != undefined &&
            this.vpicModel.destinationMarket != ""
              ? true
              : false,
          label: "Destination Market",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "displacementCC",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.displacementCC != undefined &&
            this.vpicModel.displacementCC != ""
              ? true
              : false,
          label: "Displacement CC",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "displacementCI",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.displacementCI != undefined &&
            this.vpicModel.displacementCI != ""
              ? true
              : false,
          label: "Displacement CI",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "displacementL",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.displacementL != undefined &&
            this.vpicModel.displacementL != ""
              ? true
              : false,
          label: "Displacement L",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "doors",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.doors != undefined && this.vpicModel.doors != ""
              ? true
              : false,
          label: "Doors",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "driveType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.driveType != undefined &&
            this.vpicModel.driveType != ""
              ? true
              : false,
          label: "Drive Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "driverAssist",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.driverAssist != undefined &&
            this.vpicModel.driverAssist != ""
              ? true
              : false,
          label: "Driver Assist",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "dynamicBrakeSupport",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.dynamicBrakeSupport != undefined &&
            this.vpicModel.dynamicBrakeSupport != ""
              ? true
              : false,
          label: "Dynamic Brake Support",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "edr",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.edr != undefined && this.vpicModel.edr != ""
              ? true
              : false,
          label: "EDR",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "esc",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.esc != undefined && this.vpicModel.esc != ""
              ? true
              : false,
          label: "ESC",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "evDriveUnit",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.evDriveUnit != undefined &&
            this.vpicModel.evDriveUnit != ""
              ? true
              : false,
          label: "EV Drive Unit",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "electrificationLevel",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.electrificationLevel != undefined &&
            this.vpicModel.electrificationLevel != ""
              ? true
              : false,
          label: "Electrification Level",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineConfiguration",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineConfiguration != undefined &&
            this.vpicModel.engineConfiguration != ""
              ? true
              : false,
          label: "Engine Configuration",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineCycles",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineCycles != undefined &&
            this.vpicModel.engineCycles != ""
              ? true
              : false,
          label: "Engine Cycles",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineCylinders",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineCylinders != undefined &&
            this.vpicModel.engineCylinders != ""
              ? true
              : false,
          label: "Engine Cylinders",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineHP",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineHP != undefined &&
            this.vpicModel.engineHP != ""
              ? true
              : false,
          label: "Engine HP",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineHP_to",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineHP_to != undefined &&
            this.vpicModel.engineHP_to != ""
              ? true
              : false,
          label: "Engine HP_to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineKW",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineKW != undefined &&
            this.vpicModel.engineKW != ""
              ? true
              : false,
          label: "Engine KW",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineManufacturer",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineManufacturer != undefined &&
            this.vpicModel.engineManufacturer != ""
              ? true
              : false,
          label: "Engine Manufacturer",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "engineModel",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.engineModel != undefined &&
            this.vpicModel.engineModel != ""
              ? true
              : false,
          label: "Engine Model",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "entertainmentSystem",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.entertainmentSystem != undefined &&
            this.vpicModel.entertainmentSystem != ""
              ? true
              : false,
          label: "Entertainment System",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "errorCode",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.errorCode != undefined &&
            this.vpicModel.errorCode != ""
              ? true
              : false,
          label: "Error Code",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "errorText",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.errorText != undefined &&
            this.vpicModel.errorText != ""
              ? true
              : false,
          label: "Error Text",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "forwardCollisionWarning",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.forwardCollisionWarning != undefined &&
            this.vpicModel.forwardCollisionWarning != ""
              ? true
              : false,
          label: "Forward Collision Warning",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "fuelInjectionType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.fuelInjectionType != undefined &&
            this.vpicModel.fuelInjectionType != ""
              ? true
              : false,
          label: "Fuel Injection Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "fuelTypePrimary",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.fuelTypePrimary != undefined &&
            this.vpicModel.fuelTypePrimary != ""
              ? true
              : false,
          label: "Fuel Type Primary",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "fuelTypeSecondary",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.fuelTypeSecondary != undefined &&
            this.vpicModel.fuelTypeSecondary != ""
              ? true
              : false,
          label: "Fuel Type Secondary",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "gcwr",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.gcwr != undefined && this.vpicModel.gcwr != ""
              ? true
              : false,
          label: "GCWR",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "gcwR_to",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.gcwR_to != undefined && this.vpicModel.gcwR_to != ""
              ? true
              : false,
          label: "GCWR to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "gvwR",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.gvwR != undefined && this.vpicModel.gvwR != ""
              ? true
              : false,
          label: "GVWR",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "gvwR_to",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.gvwR_to != undefined && this.vpicModel.gvwR_to != ""
              ? true
              : false,
          label: "GVWR to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "keylessIgnition",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.keylessIgnition != undefined &&
            this.vpicModel.keylessIgnition != ""
              ? true
              : false,
          label: "Keyless Ignition",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "laneCenteringAssistance",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.laneCenteringAssistance != undefined &&
            this.vpicModel.laneCenteringAssistance != ""
              ? true
              : false,
          label: "Lane Centering Assistance",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "laneDepartureWarning",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.laneDepartureWarning != undefined &&
            this.vpicModel.laneDepartureWarning != ""
              ? true
              : false,
          label: "Lane Departure Warning",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "laneKeepSystem",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.laneKeepSystem != undefined &&
            this.vpicModel.laneKeepSystem != ""
              ? true
              : false,
          label: "Lane Keep System",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "lowerBeamHeadlampLightSource",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.lowerBeamHeadlampLightSource != undefined &&
            this.vpicModel.lowerBeamHeadlampLightSource != ""
              ? true
              : false,
          label: "Lower Beam Headlamp Light Source",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "make",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.make != undefined && this.vpicModel.make != ""
              ? true
              : false,
          label: "Make",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "makeID",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.makeID != undefined && this.vpicModel.makeID != ""
              ? true
              : false,
          label: "Make ID",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "manufacturer",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.manufacturer != undefined &&
            this.vpicModel.manufacturer != ""
              ? true
              : false,
          label: "Manufacturer",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "manufacturerId",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.manufacturerId != undefined &&
            this.vpicModel.manufacturerId != ""
              ? true
              : false,
          label: "Manufacturer Id",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "model",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.model != undefined && this.vpicModel.model != ""
              ? true
              : false,
          label: "Model",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "modelID",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.modelID != undefined && this.vpicModel.modelID != ""
              ? true
              : false,
          label: "Model ID",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "modelYear",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.modelYear != undefined &&
            this.vpicModel.modelYear != ""
              ? true
              : false,
          label: "Model Year",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "motorcycleChassisType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.motorcycleChassisType != undefined &&
            this.vpicModel.motorcycleChassisType != ""
              ? true
              : false,
          label: "Motorcycle Chassis Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "motorcycleSuspensionType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.motorcycleSuspensionType != undefined &&
            this.vpicModel.motorcycleSuspensionType != ""
              ? true
              : false,
          label: "Motorcycle Suspension Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaBodyType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaBodyType != undefined &&
            this.vpicModel.ncsaBodyType != ""
              ? true
              : false,
          label: "NCSA Body Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaMake",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaMake != undefined &&
            this.vpicModel.ncsaMake != ""
              ? true
              : false,
          label: "NCSA Make",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaMapExcApprovedBy",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaMapExcApprovedBy != undefined &&
            this.vpicModel.ncsaMapExcApprovedBy != ""
              ? true
              : false,
          label: "NCSA Map ExcApproved By",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaMapExcApprovedOn",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaMapExcApprovedOn != undefined &&
            this.vpicModel.ncsaMapExcApprovedOn != ""
              ? true
              : false,
          label: "NCSA Map Exc Approved On",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaMappingException",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaMappingException != undefined &&
            this.vpicModel.ncsaMappingException != ""
              ? true
              : false,
          label: "NCSA Mapping Exception",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaModel",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaModel != undefined &&
            this.vpicModel.ncsaModel != ""
              ? true
              : false,
          label: "NCSA Model",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "ncsaNote",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.ncsaNote != undefined &&
            this.vpicModel.ncsaNote != ""
              ? true
              : false,
          label: "NCSA Note",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "nonLandUse",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.nonLandUse != undefined &&
            this.vpicModel.nonLandUse != ""
              ? true
              : false,
          label: "Non Land Use",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "note",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.note != undefined && this.vpicModel.note != ""
              ? true
              : false,
          label: "Note",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "otherBusInfo",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.otherBusInfo != undefined &&
            this.vpicModel.otherBusInfo != ""
              ? true
              : false,
          label: "Other Bus Info",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "otherEngineInfo",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.otherEngineInfo != undefined &&
            this.vpicModel.otherEngineInfo != ""
              ? true
              : false,
          label: "Other Engine Info",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "otherMotorcycleInfo",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.otherMotorcycleInfo != undefined &&
            this.vpicModel.otherMotorcycleInfo != ""
              ? true
              : false,
          label: "Other Motorcycle Info",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "otherRestraintSystemInfo",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.otherRestraintSystemInfo != undefined &&
            this.vpicModel.otherRestraintSystemInfo != ""
              ? true
              : false,
          label: "Other Restraint System Info",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "otherTrailerInfo",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.otherTrailerInfo != undefined &&
            this.vpicModel.otherTrailerInfo != ""
              ? true
              : false,
          label: "Other Trailer Info",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "parkAssist",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.parkAssist != undefined &&
            this.vpicModel.parkAssist != ""
              ? true
              : false,
          label: "Park Assist",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "pedestrianAutomaticEmergencyBraking",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.pedestrianAutomaticEmergencyBraking != undefined &&
            this.vpicModel.pedestrianAutomaticEmergencyBraking != ""
              ? true
              : false,
          label: "Pedestrian Automatic Emergency Braking",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "plantCity",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.plantCity != undefined &&
            this.vpicModel.plantCity != ""
              ? true
              : false,
          label: "Plant City",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "plantCompanyName",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.plantCompanyName != undefined &&
            this.vpicModel.plantCompanyName != ""
              ? true
              : false,
          label: "Plant Company Name",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "PlantCountry",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.PlantCountry != undefined &&
            this.vpicModel.PlantCountry != ""
              ? true
              : false,
          label: "Plant Country",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "plantState",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.plantState != undefined &&
            this.vpicModel.plantState != ""
              ? true
              : false,
          label: "Plant State",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "possibleValues",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.possibleValues != undefined &&
            this.vpicModel.possibleValues != ""
              ? true
              : false,
          label: "Possible Values",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "pretensioner",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.pretensioner != undefined &&
            this.vpicModel.pretensioner != ""
              ? true
              : false,
          label: "Pretensioner",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "rearAutomaticEmergencyBraking",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.rearAutomaticEmergencyBraking != undefined &&
            this.vpicModel.rearAutomaticEmergencyBraking != ""
              ? true
              : false,
          label: "Rear Automatic Emergency Braking",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "rearCrossTrafficAlert",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.rearCrossTrafficAlert != undefined &&
            this.vpicModel.rearCrossTrafficAlert != ""
              ? true
              : false,
          label: "Rear Cross Traffic Alert",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "rearVisibilitySystem",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.rearVisibilitySystem != undefined &&
            this.vpicModel.rearVisibilitySystem != ""
              ? true
              : false,
          label: "Rear Visibility System",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "saeAutomationLevel",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.saeAutomationLevel != undefined &&
            this.vpicModel.saeAutomationLevel != ""
              ? true
              : false,
          label: "SAE Automation Level",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "saeAutomationLevel_to",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.saeAutomationLevel_to != undefined &&
            this.vpicModel.saeAutomationLevel_to != ""
              ? true
              : false,
          label: "SAE Automation Level_to",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "seatBeltsAll",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.seatBeltsAll != undefined &&
            this.vpicModel.seatBeltsAll != ""
              ? true
              : false,
          label: "Seat Belts All",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "seatRows",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.seatRows != undefined &&
            this.vpicModel.seatRows != ""
              ? true
              : false,
          label: "Seat Rows",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "seats",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.seats != undefined && this.vpicModel.seats != ""
              ? true
              : false,
          label: "Seats",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "semiautomaticHeadlampBeamSwitching",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.semiautomaticHeadlampBeamSwitching != undefined &&
            this.vpicModel.semiautomaticHeadlampBeamSwitching != ""
              ? true
              : false,
          label: "Semiautomatic Headlamp Beam Switching",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "series",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.series != undefined && this.vpicModel.series != ""
              ? true
              : false,
          label: "Series",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "series2",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.series2 != undefined && this.vpicModel.series2 != ""
              ? true
              : false,
          label: "Series2",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "steeringLocation",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.steeringLocation != undefined &&
            this.vpicModel.steeringLocation != ""
              ? true
              : false,
          label: "Steering Location",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "suggestedVIN",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.suggestedVIN != undefined &&
            this.vpicModel.suggestedVIN != ""
              ? true
              : false,
          label: "Suggested VIN",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "tpms",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.tpms != undefined && this.vpicModel.tpms != ""
              ? true
              : false,
          label: "TPMS",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "topSpeedMPH",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.topSpeedMPH != undefined &&
            this.vpicModel.topSpeedMPH != ""
              ? true
              : false,
          label: "Top Speed MPH",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "trackWidth",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.trackWidth != undefined &&
            this.vpicModel.trackWidth != ""
              ? true
              : false,
          label: "Track Width",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "tractionControl",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.tractionControl != undefined &&
            this.vpicModel.tractionControl != ""
              ? true
              : false,
          label: "Traction Control",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "trailerBodyType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.trailerBodyType != undefined &&
            this.vpicModel.trailerBodyType != ""
              ? true
              : false,
          label: "Trailer Body Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "trailerLength",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.trailerLength != undefined &&
            this.vpicModel.trailerLength != ""
              ? true
              : false,
          label: "Trailer Length",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "trailerType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.trailerType != undefined &&
            this.vpicModel.trailerType != ""
              ? true
              : false,
          label: "Trailer Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "transmissionSpeeds",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.transmissionSpeeds != undefined &&
            this.vpicModel.transmissionSpeeds != ""
              ? true
              : false,
          label: "Transmission Speeds",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "transmissionStyle",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.transmissionStyle != undefined &&
            this.vpicModel.transmissionStyle != ""
              ? true
              : false,
          label: "Transmission Style",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "trim",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.trim != undefined && this.vpicModel.trim != ""
              ? true
              : false,
          label: "Trim",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "trim2",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.trim2 != undefined && this.vpicModel.trim2 != ""
              ? true
              : false,
          label: "Trim2",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "turbo",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.turbo != undefined && this.vpicModel.turbo != ""
              ? true
              : false,
          label: "Turbo",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "vin",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.vin != undefined && this.vpicModel.vin != ""
              ? true
              : false,
          label: "VIN",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "valveTrainDesign",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.valveTrainDesign != undefined &&
            this.vpicModel.valveTrainDesign != ""
              ? true
              : false,
          label: "Valve Train Design",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "vehicleDescriptor",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.vehicleDescriptor != undefined &&
            this.vpicModel.vehicleDescriptor != ""
              ? true
              : false,
          label: "Vehicle Descriptor",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "vehicleType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.vehicleType != undefined &&
            this.vpicModel.vehicleType != ""
              ? true
              : false,
          label: "Vehicle Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "wheelBaseLong",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.wheelBaseLong != undefined &&
            this.vpicModel.wheelBaseLong != ""
              ? true
              : false,
          label: "Wheel BaseLong",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "wheelBaseShort",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.wheelBaseShort != undefined &&
            this.vpicModel.wheelBaseShort != ""
              ? true
              : false,
          label: "Wheel Base Short",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "wheelBaseType",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.wheelBaseType != undefined &&
            this.vpicModel.wheelBaseType != ""
              ? true
              : false,
          label: "Wheel Base Type",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "wheelSizeFront",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.wheelSizeFront != undefined &&
            this.vpicModel.wheelSizeFront != ""
              ? true
              : false,
          label: "Wheel Size Front",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "wheelSizeRear",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.wheelSizeRear != undefined &&
            this.vpicModel.wheelSizeRear != ""
              ? true
              : false,
          label: "Wheel Size Rear",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "wheels",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.wheels != undefined && this.vpicModel.wheels != ""
              ? true
              : false,
          label: "Wheels",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
      {
        key: "windows",
        required: false,
        type: "v-alynk-text-field",
        templateOptions: {
          disabled: true,
          display:
            this.vpicModel.windows != undefined && this.vpicModel.windows != ""
              ? true
              : false,
          label: "Windows",
          validations: "",
          loading: false,
          elementClass:
            "col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left",
        },
      },
    ];
  }

  public async getVpicVinDecode(): Promise<void> {
    if (this.validateForm()) {
      if (!this.searchVin) {
        this.showAlert(false, "VIN field is required");
        return;
      }
      try {
        this.btnLoading = true;
        const result = await vehicleInventoryService.getVpicVinDecode(
          this.searchVin,
          this.searchModelYear
        );
        if ( result.result && result.result.vin != null &&  result.result.vin != "" ) {
          this.vpicModel = result.result;
          this.setFields();
        }else{
          this.vpicModel = {};
          this.setFields();
          this.showNotification(NotificationType.Error, "Unable to retrieve vehicle details from VPIC at this time.");
        }
      } finally {
        this.btnLoading = false;
      }
    }
  }

  public resetVpicVinDecode() {
    this.searchVin = "";
    this.searchModelYear = "";
    this.vpicModel = {};
    this.setFields();
  }
}
